export enum UserRights {
	create_meeting = 'create_meeting',
	view_all_meetings = 'view_all_meetings',
	edit_meeting_info = 'edit_meeting_info',
	edit_own_meeting_info = 'edit_own_meeting_info',
	edit_meeting_transcript = 'edit_meeting_transcript',
	edit_own_meeting_transcript = 'edit_own_meeting_transcript',
	edit_meeting_summary = 'edit_meeting_summary',
	edit_own_meeting_summary = 'edit_own_meeting_summary',
	developer = 'developer',
	admin = 'admin',
	record_meetings = 'record_meetings',
	edit_agenda = 'edit_agenda',
	edit_own_agenda = 'edit_own_agenda',
	edit_files = 'edit_files',
	edit_own_files = 'edit_own_files',
}